module.exports = __webpack_public_path__ + "img/beng.8292a8a3.gif";